export default __webpack_public_path__ + "static/media/menu-arrow.f59fdb49.svg";